// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2Kwdn","range":"MonthRangeSwitch_range__1h9C1","disabled":"MonthRangeSwitch_disabled__ssCZM"};